import { type Link as CMSLink } from '@/features/cms/components/CMS/types'
import { NextLink } from '@/features/shared/elements/Link'
import { Link } from '@shipt/design-system-typography'

type Props = {
  link?: CMSLink | null
  label: string
  onClick: () => void
}

export const ViewAllLink = ({ link, label, onClick }: Props) => {
  if (!link) return null

  return (
    <Link onClick={onClick} aria-label={label} as={NextLink} href={link.url}>
      View all
    </Link>
  )
}
